import { render, staticRenderFns } from "./RankCard.vue?vue&type=template&id=d482c858&scoped=true&"
import script from "./RankCard.vue?vue&type=script&lang=js&"
export * from "./RankCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d482c858",
  null
  
)

export default component.exports